<template>
  <div class="app-shell">
    <!-- Sidebar -->
    <AppSidenav
      v-if="$store.state.appTemplate.showSidenav"
      :collapsed="sidebarCollapsed"
    />

    <!-- Main content area -->
    <div class="app-content">
      <!-- Top navbar -->
      <AppNavbar
        v-if="$store.state.appTemplate.showNavbar"
        :sidebarCollapsed="sidebarCollapsed"
        @toggle-sidebar="sidebarCollapsed = !sidebarCollapsed"
      />

      <!-- Page content -->
      <main class="app-main">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AppSidenav from './examples/Sidenav/index.vue'
import AppNavbar from './examples/Navbars/Navbar.vue'

export default {
  name: 'App',
  components: { AppSidenav, AppNavbar },
  data() {
    return { sidebarCollapsed: false }
  },
  beforeMount() {
    this.$store.state.appTemplate.isTransparent = 'bg-transparent'
  },
}
</script>

<style>
/* Reset global */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif;
  background-color: #F8FAFC;
  -webkit-font-smoothing: antialiased;
}

.app-shell {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.app-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.app-main {
  flex: 1;
  overflow-y: auto;
}
</style>
